import mitt from 'mitt'
import type { Events } from './eventTypes'

const eventBus = mitt<Events>()

export const isEventBeenListened = (event: string) => {
  const listeners = eventBus.all.get(event as any)
  return listeners ? listeners.length > 0 : false
}

export function useEventBus() {
  return eventBus
}
